import React, { useContext, useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { getImages } from './const';

const Header = () => {
    const [isMob, setisMob] = useState(false);

    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    const [openSubMenu,  setOpenSubMenu] = useState(null)
    const handleSubMenu = (menuName) => {
        setOpenSubMenu(prev => (prev === menuName ? null : menuName));
    };
    const closeMenu = () => {
        setisMob(false); 
        setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    
    return (
        <>
            <header className={`header-wrap `}>
                <div className="container mxw-1366">
                    <div className="header-block d-flex align-items-center justify-content-between">
                        <div className="header-left">
                            <Link to="/" className="main-logo d-block">
                                <img src={getImages('Mercedes-Showroom-logo.png')} alt='Mercedes Showroom' />
                            </Link>
                        </div>
                        <div className="header-right d-flex align-items-center justify-content-between">
                            <div className={`d-flex w-100 align-items-center justify-content-between menu-block ${isMob ? 'active' : ''}`}>
                                <div className="main-menu">
                                    <ul>
                                        <li>
                                            <NavLink to="/" onClick={closeMenu}>Home</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/inventory" onClick={closeMenu}>Inventory</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/sell-your-car" onClick={closeMenu}>Sell your Car</NavLink>
                                        </li>
                                        {/* <li>
                                            <NavLink to="/our-service" onClick={closeMenu}>Service</NavLink>
                                        </li> */}
                                        {/* <li className={`sub-menu position-relative ${openSubMenu === 'service' ? 'open' : ''}`}>
                                            <NavLink to="/our-service" className='d-none d-lg-block'>Service <span className='menu-arrow-icon'></span></NavLink>
                                            <a href="#" className='d-lg-none' onClick={() => handleSubMenu('service')}>Service <span className='menu-arrow-icon'></span></a>
                                            <ul className='sub-menu-box'>
                                                <li className='w-100'>
                                                    <NavLink to="/our-service" onClick={closeMenu}>Service</NavLink>
                                                </li>
                                                <li className='w-100'>
                                                    <Link to="/" onClick={closeMenu}>Online Credit Approval</Link>
                                                </li>
                                                <li className='w-100'>
                                                    <Link to='/' onClick={closeMenu}>Trade In</Link>
                                                </li>
                                                <li className='w-100'>
                                                    <NavLink to='/transportation' onClick={closeMenu}>Transportation
</NavLink>
                                                </li>
                                            </ul>
                                        </li> */}
                                        <li>
                                            <NavLink to="/finance" onClick={closeMenu}>Finance</NavLink>
                                        </li>
                                        {/* <li>
                                            <NavLink to="/about-us" onClick={closeMenu}>About Us</NavLink>
                                        </li>
                                         */}
                                        <li className={`sub-menu position-relative ${openSubMenu === 'aboutUs' ? 'open' : ''}`}>
                                            <NavLink to="/about-us" className='d-none d-lg-block'>About Us <span className='menu-arrow-icon'></span></NavLink>
                                            <a href="#" className='d-lg-none' onClick={() => handleSubMenu('aboutUs')}>About Us <span className='menu-arrow-icon'></span></a>
                                            <ul className='sub-menu-box'>
                                                <li className='w-100'>
                                                    <NavLink to="/about-us" onClick={closeMenu}>About Us</NavLink>
                                                </li>
                                                <li className='w-100'>
                                                    <NavLink to='/transportation' onClick={closeMenu}>Transportation
</NavLink>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <NavLink to="/contact-us" onClick={closeMenu}>Contact Us</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={`overflow-bg ${isMob ? 'active' : ''
                                }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                            <div
                                className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            >
                                <div
                                    className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                        }`}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header